import { render, staticRenderFns } from "./operationRecordYJ.vue?vue&type=template&id=96a120ca&"
import script from "./operationRecordYJ.vue?vue&type=script&lang=js&"
export * from "./operationRecordYJ.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('96a120ca')) {
      api.createRecord('96a120ca', component.options)
    } else {
      api.reload('96a120ca', component.options)
    }
    module.hot.accept("./operationRecordYJ.vue?vue&type=template&id=96a120ca&", function () {
      api.rerender('96a120ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gmToolNew/operationRecord/operationRecordYJ.vue"
export default component.exports